import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=745c8ab0&scoped=true&lang=pug&"
import script from "./youtube-video.vue?vue&type=script&lang=js&"
export * from "./youtube-video.vue?vue&type=script&lang=js&"
import style0 from "./youtube-video.vue?vue&type=style&index=0&id=745c8ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c8ab0",
  null
  
)

/* custom blocks */
import block0 from "./youtube-video.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports